import styled from "styled-components";


export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        gap: 72px;
    `,
    "Footer": styled.footer`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        padding-bottom: 40px;

        & > h2 {
            ${({ theme }) => theme.font["medium-bold"]};
            margin-bottom: 8px;
        }

        & > p {
            ${({ theme }) => theme.font["xsmall-semibold"]};
            color: ${({ theme }) => theme.color["grey3"]};

            & > span {
                ${({ theme }) => theme.font["xsmall-regular"]};
                color: ${({ theme }) => theme.color["grey3"]};
            }
        }
    `
}